<template>
  <span>
    <div id="app">
      <v-app light>
        <v-toolbar max-height="64px">
          <v-toolbar-title>Bolsa de Trabajo</v-toolbar-title>
          <v-toolbar-title class="text--secondary mx-2 my-2 mb-1 text-overline"
            >Alumnos</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn color="bolsa-green" text icon :to="{ name: 'Landing' }">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </v-toolbar>
        <v-main>
          <section>
            <v-container
              fluid
              class="d-flex justify-center align-center"
              style="height: 75vh"
            >
              <v-row align="center" justify="center">
                <v-col cols="12" md="5" sm="12" class="pt-4 pb-0">
                  <div class="d-flex justify-center">
                    <div class="d-inline-flex flex-column">
                      <div class="text-center">
                        <v-btn
                          class="my-4"
                          elevation="6"
                          :to="{ name: 'RegistroEmpresa' }"
                        >
                          <span style="white-space: normal"
                            >¿Quieres registrarte como Empresa?</span
                          >
                          <v-icon right size="18">mdi-arrow-right-bold</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col cols="12" md="6" sm="12">
                  <v-row align="center" justify="center">
                    <v-col cols="12" md="8" sm="12">
                      <v-card elevation="4">
                        <div class="d-flex justify-center">
                          <v-card-title class="pa-0 pt-4"
                            >Registro de Alumno</v-card-title
                          >
                        </div>

                        <v-card-text>
                          <v-form
                            ref="formAlumno"
                            v-model="validAlumno"
                            lazy-validation
                          >
                            <v-text-field
                              ref="codigoUNI"
                              v-model="alumno.codigoUNI"
                              :rules="[
                                () =>
                                  !!alumno.codigoUNI ||
                                  'El código UNI es obligatorio',
                                () =>
                                  (!!alumno.codigoUNI &&
                                    alumno.codigoUNI.length <= 9) ||
                                  'El código UNI es de máximo 9 caracteres'
                              ]"
                              label="Código UNI"
                              placeholder="20101234A"
                              prepend-icon="mdi-badge-account"
                              counter="9"
                              :readonly="reenvioMail"
                              required
                              color="bolsa-color-primario"
                            ></v-text-field>
                            <v-text-field
                              ref="correoUNI"
                              v-model="alumno.correo"
                              :rules="[
                                () =>
                                  !!alumno.correo || 'El correo es obligatorio'
                              ]"
                              :readonly="reenvioMail"
                              autocomplete="off"
                              placeholder="ejemplo@uni.pe"
                              prepend-icon="mdi-card-account-mail"
                              color="bolsa-color-primario"
                            >
                              <template v-slot:label>
                                Correo Electrónico
                                <small>(ORCE)</small>
                              </template>
                            </v-text-field>
                            <v-autocomplete
                              ref="carreraAlumno"
                              v-model="alumno.carreraId"
                              :rules="[
                                () =>
                                  !!alumno.carreraId ||
                                  'Debes seleccionar una Especialidad'
                              ]"
                              :items="carrerasDisponibles"
                              :readonly="reenvioMail"
                              item-text="nombreEspecialidad"
                              item-value="_id"
                              label="Carrera"
                              prepend-icon="mdi-account-hard-hat"
                              placeholder="Selecciona tu Especialidad"
                              required
                            ></v-autocomplete>
                          </v-form>
                          <v-alert
                            dense
                            border="left"
                            type="error"
                            v-if="getError.error"
                            >{{ getError.errorMessage }}</v-alert
                          >
                          <v-alert type="success" v-if="successAlert"
                            >Te has registrado correctamente, revisa tu correo
                            electrónico para poder acceder a la
                            plataforma</v-alert
                          >
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-btn text @click="resetAlumnoForm">Limpiar</v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :dark="validAlumno"
                            color="green"
                            :loading="fetching"
                            :disabled="!validAlumno"
                            v-if="!reenvioMail"
                            @click="registrarAlumno"
                            >Registrar</v-btn
                          >
                          <v-btn
                            v-else
                            :dark="validAlumno"
                            color="green"
                            :loading="fetching"
                            :disabled="!validAlumno"
                            @click="registrarAlumnoReenvio"
                            >Reenviar Correo</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </section>
        </v-main>
      </v-app>
    </div>
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RegistroAlumno',
  data() {
    return {
      validAlumno: false,
      showPassword: false,
      alumno: {
        codigoUNI: '',
        correo: '',
        carreraId: ''
      },
      carrerasDisponibles: [],
      successAlert: false,
      reenvioMail: false
    }
  },

  computed: {
    ...mapGetters('user', ['getListaCarreras', 'getError', 'fetching'])
  },

  methods: {
    resetAlumnoForm() {
      this.$refs.formAlumno.reset()
    },

    async registrarAlumno() {
      this.successAlert = false
      if (this.$refs.formAlumno.validate()) {
        let { ...body } = this.alumno
        let response = await this.postRegistrar(body)
        if (response.success) {
          this.successAlert = true
          this.$refs.formAlumno.reset()
          this.validAlumno = false
        } else {
          if (response == 91) {
            this.reenvioMail = true
          }
        }
      }
    },

    async registrarAlumnoReenvio() {
      this.successAlert = false
      if (this.$refs.formAlumno.validate()) {
        let { ...body } = this.alumno
        body.reenviarMail = true
        let response = await this.postRegistrar(body)
        if (response.success) {
          this.reenvioMail = false
          this.successAlert = true
          this.$refs.formAlumno.reset()
          this.validAlumno = false
        }
      }
    },

    ...mapActions('user', ['getCarreras']),
    ...mapActions('publicModule', ['postRegistrar'])
  },

  async mounted() {
    this.validAlumno = false
    await this.getCarreras()
    this.carrerasDisponibles = this.getListaCarreras
  }
}
</script>

<style>
html {
  overflow-y: auto;
}

.slide-group {
  position: relative;
}

.slide-item {
  position: absolute;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>
